import type { ComponentProps } from 'react';

import classNames from 'classnames';

import type { FCC } from '../../types/common';
import Panels from '../panels/panels';

import styles from './panels_admin.module.css';

type Props = ComponentProps<typeof Panels>;

const PanelsAdmin: FCC<Props> = (props) => (
  <Panels
    {...props}
    showSideMenu={false}
    className={classNames(styles.panels, props.className)}
  />
);

export default PanelsAdmin;
